import type { ComponentType } from 'react';

export interface BlogPost {
  slug: string;
  title: string;
  description: string;
  date: string;
  tags: string[];
  Component: ComponentType<Record<string, unknown>>;
}

interface MdxModule {
  default: ComponentType<Record<string, unknown>>;
  meta: { title: string; description: string; date: string; tags?: string[] };
}

const modules = import.meta.glob<MdxModule>('../../content/blog/*.mdx', { eager: true });

export const posts: BlogPost[] = Object.entries(modules)
  .map(([path, mod]) => ({
    slug: path.replace(/^.*\/([^/]+)\.mdx$/, '$1'),
    title: mod.meta.title,
    description: mod.meta.description,
    date: mod.meta.date,
    tags: mod.meta.tags ?? [],
    Component: mod.default,
  }))
  .sort((a, b) => b.date.localeCompare(a.date));

export function getPost(slug: string): BlogPost | undefined {
  return posts.find((p) => p.slug === slug);
}
